export const tokenMintStages = [
    {
        name: 'upload',
        title: 'Publishing to IPFS',
        content: 'Content is uploading to IPFS storage',
        doneContent: 'Content has been uploaded to IPFS storage',
    },
    {
        name: 'sign',
        title: 'Signing transaction',
        content: 'Please sign using your wallet',
        doneContent: 'Transaction signed',
    },
    {
        name: 'mint',
        title: 'Minting token',
        content: 'Uploading data to the blockchain',
        doneContent: 'Data has been uploaded to the blockchain',
    },
    {
        name: 'confirm',
        title: 'Confirmation',
        content: 'Transaction must be confirmed',
        doneContent: 'Transaction have been successfully confirmed',
    },
];
